import { Col, Descriptions, Row } from 'antd';
import Sorefsis from 'components/sorefsis';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { printInfo , getFullDateTimeWithSeconds } from 'store/appTrack/utils';
import {ReactComponent as GroupIcons} from '../../../../../assets/icons/group_icons.svg';
import { useSelector, useDispatch } from 'react-redux';
import IntervCostTable from './IntervCostTable';

const concatDashes = (input) => input.split(" ").every(it => it === "-") ? "-" : input

const BasicInfo = () => { 

  const apptrackDetails = useSelector(state=>state.appTrack.apptrackDetails);

  const response = Object.keys(apptrackDetails?.variablesIndexed).length === 1 && apptrackDetails?.variablesIndexed.hasOwnProperty('initiator')
    ? apptrackDetails?.localTaskVariables
    : apptrackDetails?.variablesIndexed;

  return (
    <div className=''>
      <div style={{display:"flex"}}>
        <Descriptions
          title="Στοιχεία Αίτησης"
          bordered
          className="large-titles-purple-responsive investment-plan-details-table"
          style={{width:"47%", marginRight:"6%"}}
          column={1}
        >
          <Descriptions.Item label="Δήμος">
            {printInfo(response.companyName)}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Φ.Μ. Δήμου">
            {printInfo(response.abiVat)}
          </Descriptions.Item>
          {/* <Descriptions.Item label="Ημ. Σύστασης">
            {printInfo(response.regDate)}
          </Descriptions.Item> */}
          <Descriptions.Item label="Οδός - Αριθμός">
            {printInfo(response.abiStreetFull)}
          </Descriptions.Item>
          <Descriptions.Item label="Τ.Κ.">
            {printInfo(response?.abiTk)}
          </Descriptions.Item>
          <Descriptions.Item label="Νομός">
            {printInfo(response.abiPerfecture)}
          </Descriptions.Item>
          <Descriptions.Item label="Περιοχή">
            {printInfo(response.abiDistrict)}
          </Descriptions.Item>
          <Descriptions.Item label="Τηλέφωνο">
            {printInfo(response.invMob)}
          </Descriptions.Item>
          <Descriptions.Item label="Ιστοχώρος">
          {printInfo(response.website)}
          </Descriptions.Item>
          <Descriptions.Item label="E-mail">
            {printInfo(response.invMail)}
          </Descriptions.Item>
        </Descriptions>

        <Descriptions
          title="Τόπος Εκτέλεσης"
          bordered
          className="large-titles-purple-responsive investment-plan-details-table"
          style={{width:"47%"}}
          column={1}
        >
          <Descriptions.Item label="Βαθμίδα Σχολείου">
            {printInfo(response.schoolGrade)}
          </Descriptions.Item>
          <Descriptions.Item label="Χαρακτηριστικό Όνομα">
            {printInfo(response.buildName)}
          </Descriptions.Item>
          <Descriptions.Item label="Πολεοδομική Χρήση">
            {printInfo(response.buildUsage)}
          </Descriptions.Item>
          <Descriptions.Item label="Έτος Κατασκευής">
            {printInfo(response.buildYear)}
          </Descriptions.Item>
          <Descriptions.Item label="Οδός - Αριθμός">           
            {printInfo(response.buildStreet)}
          </Descriptions.Item>
          <Descriptions.Item label="Τ.Κ.">
            {typeof(response?.buildTk) !== 'object' ? printInfo(response?.buildTk) : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Νομός">
            {printInfo(response.buildPerfecture)}
          </Descriptions.Item>
          <Descriptions.Item label="Περιοχή">
            {printInfo(response.buildDistrict)}
          </Descriptions.Item>
          <Descriptions.Item label="Αρ. Παροχής Ρεύματος">
            {printInfo(response.powerSupNo)}
          </Descriptions.Item>
          <Descriptions.Item label="Ωφέλιμη Επιφάνεια">
            {printInfo(response.usableArea)}
          </Descriptions.Item>
          <Descriptions.Item label="Συνολική Επιφάνεια">
            {printInfo(response.totalArea)}
          </Descriptions.Item>
          <Descriptions.Item label="Βαθμοημέρες">
            {printInfo(response.degDays)}
          </Descriptions.Item>
          {response.coHousing && (
            <>
              <Descriptions.Item label="Χαρακτηριστικό Όνομα Συστεγασμένου">
                {printInfo(response.coHousingName)}
              </Descriptions.Item>
              <Descriptions.Item label="Βαθμίδα Συστεγασμένου">
                {printInfo(response.schoolGradeCo)}
              </Descriptions.Item>
            </>
          )}
        </Descriptions>
      </div>

      <div className='d-flex'>
        <Descriptions
          title="Νόμιμος Εκπρόσωπος"
          bordered
          className="large-titles-purple descriptions-table-graye"
          style={{width:"47%", marginRight:"6%"}}
          column={1}
        >
          <Descriptions.Item label="Ονοματεπώνυμο">
            {concatDashes(`${printInfo(response.legalName)} ${printInfo(response.legalSurname)}`)}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Φ.Μ.">
            {printInfo(response.legalVat)}
          </Descriptions.Item>
          <Descriptions.Item label="Τηλέφωνο Επικοινωνίας">
            {printInfo(response.legalPhone)}
          </Descriptions.Item>
          <Descriptions.Item label="E-mail Επικοινωνίας">
            {printInfo(response.legalEmail)}
          </Descriptions.Item>
        </Descriptions>
        
        <Descriptions
          title="Υπεύθυνος Επικοινωνίας"
          bordered
          className="large-titles-purple descriptions-table-graye"
          column={1}
          style={{width:"47%"}}
        >
          <Descriptions.Item label="Ονοματεπώνυμο">
          {concatDashes(`${printInfo(response.contactPersonFlag ? response.legalName : response.contactName)} ${printInfo(response.contactPersonFlag ? response.legalSurname : response.contactSurname)}`)}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Φ.Μ.">
            {printInfo(response.contactPersonFlag ? response.legalVat : response.contactVat)}
          </Descriptions.Item>
          <Descriptions.Item label="Τηλέφωνο Επικοινωνίας">
            {printInfo(response.contactPersonFlag ? response.legalPhone : response.contactPhone)}
          </Descriptions.Item>
          <Descriptions.Item label="E-mail Επικοινωνίας">
            {printInfo(response.contactPersonFlag ? response.legalEmail : response.contactEmail)}
          </Descriptions.Item>
        </Descriptions>
        
      </div>
      <IntervCostTable data={response}/>
    </div>
    
  );
};

export default BasicInfo;